import * as React from "react";
import { connect } from "react-redux";
import { Redirect, RouteComponentProps } from "react-router";
import { Action, Dispatch } from "redux";
import { OuterURL } from "src/config/view_const/outer_url";
import { frontEndConfig } from "../../config/config";
import { Pager } from "../../domain/model/common";
import { Customer, Status } from "../../domain/model/customer";
import {
  Occupation,
  PaymentRange,
  WorkingDuration,
  WorkingHourRange,
} from "../../domain/model/project";
import { entity } from "../../infra/api/rpc/api";
import { createCustomerProjectListActionCreator } from "../action/customer_projects_action";
import ProjectsComponent from "../component/customer/projects/customer_projects";
import {
  createCustomerProjectListDispatcher,
  ICustomerProjectListDispatcher,
} from "../dispatcher/customer_projects_dispatcher";
import {
  GetEntryNumOrderProjectListByCustomerRequest,
  SearchProjectListByCustomerRequest,
} from "../request/project_request";
import { AppState } from "../store/app_state";
import { AuthState } from "../store/auth_state";
import { CustomerProjectListState } from "../store/customer_projects_state";
import { TPagination, TSearchQueryForProjects } from "../type/common";

const defaultOffset = 12;
const pageRangeDisplayed: number = frontEndConfig.defaultPageRangeDisplayed;

interface IProps extends RouteComponentProps<{}> {
  state: CustomerProjectListState;
  authState: AuthState;
  dispatcher: ICustomerProjectListDispatcher;
}

interface IState {
  isInit: boolean;
}

export class CustomerProjects extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      isInit: true,
    };
  }

  public componentDidMount() {
    const { authState } = this.props;
    const req: GetEntryNumOrderProjectListByCustomerRequest =
      new GetEntryNumOrderProjectListByCustomerRequest();
    const pager: Pager = new Pager(1, defaultOffset);
    req.pager = pager;
    this.props.dispatcher.getEntryNumOrderProjectList(req);

    // 直接アクセスの際のデータ取得
    const params: TSearchQueryForProjects = this.helperForSearchPrams(
      this.props.location.search
    );
    this.pushQueryString(params);
  }

  public componentWillReceiveProps(
    nextProps: Readonly<IProps>,
    nextContext: any
  ): void {
    // URL遷移の際のデータ取得
    if (nextProps.location !== this.props.location) {
      const params: TSearchQueryForProjects = this.helperForSearchPrams(
        nextProps.location.search
      );
      const pager: Pager = new Pager(params.activePage, defaultOffset);
      const req: SearchProjectListByCustomerRequest =
        new SearchProjectListByCustomerRequest();
      req.page = pager.page;
      req.offset = pager.offset;
      req.q = params.query;
      if (params.occupation) {
        req.occupation = params.occupation;
      }
      if (params.workingHourRange) {
        req.workingHourRange = params.workingHourRange;
      }
      if (params.paymentRange) {
        req.paymentRange = params.paymentRange;
      }
      if (params.workingDuration) {
        req.workingDuration = params.workingDuration;
      }
      this.props.dispatcher.searchProjectList(req);
    }
  }

  public componentDidUpdate(prevProps: IProps, prevState: IState) {
    // init処理の終了
    const isInitFinished: boolean =
      this.state.isInit &&
      !this.props.state.isLoading &&
      prevProps.state.isLoading;
    if (isInitFinished) {
      return this.setState({ isInit: false });
    }
  }

  public render(): JSX.Element {
    const { location, state, authState } = this.props;
    const { isInit } = this.state;
    const {
      projects,
      projectCount,
      companiesWithProjectID,
      newlyArrivedProjects,
      companiesWithNewlyArrivedProjectID,
      entryNumOrderProjects,
      companiesWithEntryNumOrderProjectID,
      isLoading,
    } = state;

    const customer: Customer | null = authState.user && authState.user.customer;
    const isStatusInspection: boolean = customer
      ? customer.status === Status.Status_Inspection
      : false;
    const isActive = customer
      ? customer.status === Status.Status_Active
      : false;

    const totalItemsCount: number = state.projectCount;
    const itemsCountPerPage: number = defaultOffset;

    const params: TSearchQueryForProjects = this.helperForSearchPrams(
      location.search
    );

    const paginationPrams: TPagination = {
      activePage: params.activePage,
      itemsCountPerPage,
      totalItemsCount,
      pageRangeDisplayed,
      onChange: this.handlePageChange,
    };

    if (customer!.type === entity.Customer.Type.Type_Pro) {
      return <Redirect to="/" />;
    }

    return (
      <ProjectsComponent
        isInit={isInit}
        isLoading={isLoading}
        customer={customer}
        isActive={isActive}
        handleNextStep={this.handleNextStep}
        isStatusInspection={isStatusInspection}
        projects={projects}
        projectCount={projectCount}
        companiesWithProjectID={companiesWithProjectID}
        newlyArrivedProjects={newlyArrivedProjects}
        companiesWithNewlyArrivedProjectID={companiesWithNewlyArrivedProjectID}
        entryNumOrderProjects={entryNumOrderProjects}
        companiesWithEntryNumOrderProjectID={
          companiesWithEntryNumOrderProjectID
        }
        searchFormInitValues={{
          q: params.query,
          occupation: params.occupation,
          workingHourRange: params.workingHourRange,
          paymentRange: params.paymentRange,
          workingDuration: params.workingDuration,
        }}
        paginationPrams={paginationPrams}
        handleSearch={this.handleSearch}
        handleOccupationChange={this.handleOccupationChange}
        handleWorkingHourRangeChange={this.handleWorkingHourRangeChange}
        handlePaymentRangeChange={this.handlePaymentRangeChange}
        handleWorkingDurationChange={this.handleWorkingDurationChange}
      />
    );
  }

  private handleNextStep = (): void => {
    window.open(OuterURL.calendlyURL, "_blank");
  };

  private helperForSearchPrams = (
    urlSearchParams: any
  ): TSearchQueryForProjects => {
    const params = new URLSearchParams(urlSearchParams);

    let occupation: number = Number(params.get("o"));
    let workingHourRange: number = Number(params.get("wh"));
    let paymentRange: number = Number(params.get("pr"));
    let workingDuration: number = Number(params.get("wd"));
    const query: string = params.get("q") ? String(params.get("q")) : "";
    let activePage: number = params.get("p") ? Number(params.get("p")) : 1;

    if (Number.isNaN(occupation)) {
      occupation = 0;
    }
    if (Number.isNaN(workingHourRange)) {
      workingHourRange = 0;
    }
    if (Number.isNaN(paymentRange)) {
      paymentRange = 0;
    }
    if (Number.isNaN(workingDuration)) {
      workingDuration = 0;
    }
    if (Number.isNaN(activePage)) {
      activePage = 1;
    }

    const res: TSearchQueryForProjects = {
      occupation,
      workingHourRange,
      paymentRange,
      workingDuration,
      query,
      activePage,
    };
    return res;
  };

  private pushQueryString = (searchQuery: TSearchQueryForProjects): void => {
    const { location, history } = this.props;
    const params = new URLSearchParams(location.search);
    searchQuery.occupation
      ? params.set("o", String(searchQuery.occupation))
      : params.delete("o");
    searchQuery.workingHourRange
      ? params.set("wh", String(searchQuery.workingHourRange))
      : params.delete("wh");
    searchQuery.paymentRange
      ? params.set("pr", String(searchQuery.paymentRange))
      : params.delete("pr");
    searchQuery.workingDuration
      ? params.set("wd", String(searchQuery.workingDuration))
      : params.delete("wd");
    params.set("q", String(searchQuery.query));
    params.set("p", searchQuery.activePage.toString());
    history.push({
      search: params.toString(),
    });
  };

  private handlePageChange = (pageNumber: number): void => {
    const params = new URLSearchParams(this.props.location.search);

    let occupation: number = Number(params.get("o"));
    let workingHourRange: number = Number(params.get("wh"));
    let paymentRange: number = Number(params.get("pr"));
    let workingDuration: number = Number(params.get("wd"));
    const query: string = params.get("q") ? String(params.get("q")) : "";
    const activePage: number = pageNumber;

    if (Number.isNaN(occupation)) {
      occupation = 0;
    }
    if (Number.isNaN(workingHourRange)) {
      workingHourRange = 0;
    }
    if (Number.isNaN(paymentRange)) {
      paymentRange = 0;
    }
    if (Number.isNaN(workingDuration)) {
      workingDuration = 0;
    }

    const searchQuery: TSearchQueryForProjects = {
      occupation,
      workingHourRange,
      paymentRange,
      workingDuration,
      query,
      activePage,
    };
    this.pushQueryString(searchQuery);
  };

  private handleSearch = (values: any): void => {
    let occupation: Occupation = Number(values.occupation);
    let workingHourRange: WorkingHourRange = Number(values.workingHourRange);
    let paymentRange: PaymentRange = Number(values.paymentRange);
    let workingDuration: WorkingDuration = Number(values.workingDuration);

    const query: string = values.q ? values.q : "";
    let activePage: number = 1;

    if (Number.isNaN(occupation)) {
      occupation = 0;
    }
    if (Number.isNaN(workingHourRange)) {
      workingHourRange = 0;
    }
    if (Number.isNaN(paymentRange)) {
      paymentRange = 0;
    }
    if (Number.isNaN(workingDuration)) {
      workingDuration = 0;
    }
    if (Number.isNaN(activePage)) {
      activePage = 1;
    }

    const searchQuery: TSearchQueryForProjects = {
      occupation,
      workingHourRange,
      paymentRange,
      workingDuration,
      query,
      activePage,
    };
    this.pushQueryString(searchQuery);
  };

  private handleOccupationChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    let occupation = Number(event.currentTarget.value);
    if (Number.isNaN(occupation)) {
      occupation = Occupation.Occupation_Unknown;
    }
    const params: TSearchQueryForProjects = this.helperForSearchPrams(
      this.props.location.search
    );
    const searchQuery: TSearchQueryForProjects = {
      ...params,
      occupation,
    };
    this.pushQueryString(searchQuery);
  };

  private handleWorkingHourRangeChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    let workingHourRange = Number(event.currentTarget.value);
    if (Number.isNaN(workingHourRange)) {
      workingHourRange = WorkingHourRange.WorkingHourRange_Unknown;
    }
    const params: TSearchQueryForProjects = this.helperForSearchPrams(
      this.props.location.search
    );
    const searchQuery: TSearchQueryForProjects = {
      ...params,
      workingHourRange,
    };
    this.pushQueryString(searchQuery);
  };

  private handlePaymentRangeChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    let paymentRange = Number(event.currentTarget.value);
    if (Number.isNaN(paymentRange)) {
      paymentRange = PaymentRange.PaymentRange_Unknown;
    }
    const params: TSearchQueryForProjects = this.helperForSearchPrams(
      this.props.location.search
    );
    const searchQuery: TSearchQueryForProjects = {
      ...params,
      paymentRange,
    };
    this.pushQueryString(searchQuery);
  };

  private handleWorkingDurationChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    let workingDuration = Number(event.currentTarget.value);
    if (Number.isNaN(workingDuration)) {
      workingDuration = WorkingDuration.WorkingDuration_Unknown;
    }
    const params: TSearchQueryForProjects = this.helperForSearchPrams(
      this.props.location.search
    );
    const searchQuery: TSearchQueryForProjects = {
      ...params,
      workingDuration,
    };
    this.pushQueryString(searchQuery);
  };
}

const mapStateToProps = (state: AppState) => {
  return {
    state: state.customerProjectListReducer,
    authState: state.authReducer,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
  return {
    dispatcher: createCustomerProjectListDispatcher(
      dispatch,
      createCustomerProjectListActionCreator()
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerProjects);



// WEBPACK FOOTER //
// ./src/presentation/container/customer_projects_container.tsx